<template>
  <dx-counterparty-form
    next-step-path="SelfService-ReportDamage-ThankYou"
    previous-step-path="SelfService-ReportDamage-Deadline"
    create-claim-action="createLegalClaim"
  />
</template>

<script>
import DxCounterpartyForm from '~/components/reportDamage/DX-CounterpartyForm'

export default {
  name: 'ReportDamageCounterparty',
  components: {
    DxCounterpartyForm,
  },
  layout: 'non-sticky-nav',
  nuxtI18n: {
    paths: {
      de: '/kundencenter/schaden-melden/gegenpartei',
      fr: '/centre-clients/dommages-rapport/contrepartie',
      it: '/cliente/danni-report/controparte',
    },
  },
}
</script>
